import PortalClienteService from "services/bases/PortalClienteService";

class AssinaturasService extends PortalClienteService{
    async ListarAssinaturasPorDireito(tenantId){
        return await this.get(`assinaturas/${tenantId}`)
    }

    async ValidarSeLicencaDentroDaJanelaCancelamento(data) {
        return await this.post(`assinaturas/ValidarSeLicencaDentroDaJanelaCancelamento`, data);
    }
}

export default new AssinaturasService();